import React, { useState } from "react";
import { Modal, Form, Input, Upload, Image, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useEffect } from "react";

const AddModal = ({ isModalVisible, handleOk, handleCancel, loading }) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  const handleChange = ({ fileList }) => {
    setFileList(fileList.slice(-1));
    form.setFieldsValue({ image: fileList.length > 0 ? fileList[0] : null });
  };

  const handlePreview = async (file) => {
    const reader = new FileReader();
    reader.onload = (e) => setPreviewImage(e.target.result);
    reader.readAsDataURL(file.originFileObj);
    setPreviewOpen(true);
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Select</div>
    </div>
  );

  const onFinish = (values) => {
    handleOk({ ...values, image: fileList[0]?.originFileObj || null });
  };

  useEffect(() => {
    form.resetFields();
    setFileList([]);
    setPreviewImage("");
  }, [form, isModalVisible]);

  return (
    <Modal
      title="Add New Preference Master"
      open={isModalVisible}
      footer={null} // Remove default buttons
      onCancel={() => {
        handleCancel();
        form.resetFields();
        setFileList([]);
        setPreviewImage("");
      }}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="name"
          label="Preference Name"
          rules={[{ required: true, message: "Please enter Preference Name" }]}
        >
          <Input placeholder="Enter Preference Name" />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: "Please enter Description" }]}
        >
          <Input.TextArea rows={3} placeholder="Enter Description" />
        </Form.Item>
        <Form.Item
          name="image"
          label="Select Image"
          rules={[{ required: true, message: "Please upload an image" }]}
          dependencies={["image"]}
        >
          <Upload
            listType="picture-card"
            fileList={fileList}
            onPreview={handlePreview}
            onChange={handleChange}
            beforeUpload={() => false} // Prevent default upload behavior
            maxCount={1}
            accept=".jpg,.jpeg,.png,.svg"
            onRemove={async (file) => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "Are you sure you want to delete this image?",
                  okText: "Yes",
                  cancelText: "No",
                  onOk: () => {
                    resolve(true); // allow deletion
                  },
                  onCancel: () => {
                      resolve(false) // cancel deletion
                  },
                });
              });
            }}
          >
            {fileList.length >= 1 ? null : uploadButton}
          </Upload>
          {previewImage && (
            <Image
              wrapperStyle={{ display: "none" }}
              preview={{
                visible: previewOpen,
                onVisibleChange: (visible) => setPreviewOpen(visible),
                afterOpenChange: (visible) => !visible && setPreviewImage(""),
                toolbarRender: () => null,
              }}
              src={previewImage}
            />
          )}
        </Form.Item>
        <Form.Item>
          <div className="flex items-center justify-end gap-4">
            <Button onClick={handleCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Submit
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddModal;
